import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
  name: "firstFromSplit",
  standalone: false,
})
export class FirstFromSplitPipe implements PipeTransform {
  transform(value: string, char = ""): string {
    if (!value || char === "") return value;
    value = value.split(char)[0];
    return value;
  }
}
